/**
 * Timezone
 */
 export const Timezone = (function () {

  var init = function () {
    addEventListeners();
  }
  /**
   * EVENT LISTENER FUNCTIONS
   */
  function addEventListeners() {
    $('.myds-timezone-select').on('change', function (event) {
      var selected = $(this).find(':selected').val();
      var promise = update(selected);
      handleResponse(promise);
    });
    // Set timezone in UI
    $( document ).ready(function() {
      var timezone = $('.myds-timezone-select').attr('data-value');
      if(timezone) {
        $(`.myds-timezone-select option[value='${timezone}']`).prop('selected', true);
      }
    });
  }
  /**
   * HTTP FUNCTIONS
   */
  function update(selected) {
    var csrf = Util.getCSRF();
    return $.ajax({
      url: `/variables/mydex_preferences_user_timezone/update`,
      type: 'post',
      data:  {
        value : selected
      },
      headers: {
        'x-csrf-token': csrf
      },
    });
  }

  function handleResponse( promise ) {
    promise.then(function () {
        Util.toggleAlert('.alert', "Success: Timezone Changed!", 'alert-success');
    });
    promise.fail(function (response) {
        var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
        Util.toggleAlert('.alert', message , 'alert-warning');
    }); 
  }

  return {
    init: init
  }

}());


